/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { deliveryOrderSchema } from "./deliveryOrderSchema.ts";
import { errorResponseSchema } from "./errorResponseSchema.ts";

export const deliveryOrdersCancelCreatePathOrderIdSchema = z.uuid();

export const deliveryOrdersCancelCreateStatus200Schema = deliveryOrderSchema;

export const deliveryOrdersCancelCreateStatus400Schema = errorResponseSchema;

export const deliveryOrdersCancelCreateResponseSchema = z.union([deliveryOrdersCancelCreateStatus200Schema, deliveryOrdersCancelCreateStatus400Schema]);
